import { useEffect, useRef, useState } from "react";
import { X, Eraser, Check, Loader2 } from "lucide-react";

export default function SignaturePad({ title, onConfirm, onClose, saving }) {
  const canvasRef = useRef(null);
  const drawingRef = useRef(false);
  const [hasInk, setHasInk] = useState(false);

  useEffect(() => {
    const canvas = canvasRef.current;
    const dpr = window.devicePixelRatio || 1;
    const rect = canvas.getBoundingClientRect();
    canvas.width = rect.width * dpr;
    canvas.height = rect.height * dpr;
    const ctx = canvas.getContext("2d");
    ctx.scale(dpr, dpr);
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, rect.width, rect.height);
    ctx.strokeStyle = "#0f172a";
    ctx.lineWidth = 2.5;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
  }, []);

  const pos = (e) => {
    const rect = canvasRef.current.getBoundingClientRect();
    return { x: e.clientX - rect.left, y: e.clientY - rect.top };
  };
  const start = (e) => {
    e.preventDefault();
    drawingRef.current = true;
    const ctx = canvasRef.current.getContext("2d");
    const p = pos(e);
    ctx.beginPath();
    ctx.moveTo(p.x, p.y);
  };
  const move = (e) => {
    if (!drawingRef.current) return;
    e.preventDefault();
    const ctx = canvasRef.current.getContext("2d");
    const p = pos(e);
    ctx.lineTo(p.x, p.y);
    ctx.stroke();
    setHasInk(true);
  };
  const end = () => { drawingRef.current = false; };

  const clear = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const rect = canvas.getBoundingClientRect();
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, rect.width, rect.height);
    setHasInk(false);
  };

  const confirm = () => {
    if (!hasInk) return;
    onConfirm(canvasRef.current.toDataURL("image/png"));
  };

  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center p-4" style={{ background: "rgba(5,8,18,0.9)", backdropFilter: "blur(6px)" }} onClick={onClose} data-testid="signature-pad-modal">
      <div className="w-full max-w-md panel-strong" onClick={(e) => e.stopPropagation()}>
        <div className="px-5 py-3.5 border-b flex items-center justify-between" style={{ borderColor: "var(--border)" }}>
          <div>
            <div className="label-mono">// FIRMA DE RECIBIDO</div>
            {title && <div className="text-xs text-slate-400 mt-0.5">{title}</div>}
          </div>
          <button type="button" onClick={onClose} className="btn-ghost p-1.5 rounded-sm"><X className="w-4 h-4" /></button>
        </div>
        <div className="p-4">
          <canvas
            ref={canvasRef}
            data-testid="signature-canvas"
            className="w-full rounded-sm cursor-crosshair"
            style={{ height: 200, touchAction: "none", background: "#fff", border: "2px dashed #94a3b8" }}
            onPointerDown={start}
            onPointerMove={move}
            onPointerUp={end}
            onPointerLeave={end}
          />
          <p className="text-[11px] text-slate-500 mt-2 text-center">Firma con el dedo o el mouse dentro del recuadro</p>
        </div>
        <div className="px-5 py-3.5 border-t flex justify-between gap-2" style={{ borderColor: "var(--border)" }}>
          <button type="button" onClick={clear} data-testid="signature-clear-btn" className="btn-ghost px-3 py-2 rounded-sm text-xs uppercase tracking-widest flex items-center gap-1.5">
            <Eraser className="w-3.5 h-3.5" /> Borrar
          </button>
          <button type="button" onClick={confirm} disabled={!hasInk || saving} data-testid="signature-confirm-btn" className="btn-primary px-4 py-2 rounded-sm text-xs uppercase tracking-widest flex items-center gap-1.5 disabled:opacity-40">
            {saving ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Check className="w-3.5 h-3.5" />} Confirmar firma
          </button>
        </div>
      </div>
    </div>
  );
}
